var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"defaultLayout"}},[_c('div',{staticClass:"top-degrade"}),_c('main-top-menu'),_c('div',{staticClass:"main-container"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }